import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../ui/command";
import { ChevronsUpDown, PenLine } from "lucide-react";
import { fmt } from "./api";

export function MenuPicker({ menu, center, country, value, label, onPick, onCustom, testid }) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="flex h-8 w-56 items-center justify-between rounded border px-2 text-left text-xs" data-testid={testid}>
          <span className="truncate">{value ? label : "Search menu item…"}</span><ChevronsUpDown className="h-3 w-3 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="start">
        <button type="button" className="flex w-full items-center border-b px-3 py-2 text-left text-xs hover:bg-slate-50" onClick={() => { onCustom(); setOpen(false); }} data-testid={`${testid}-custom`}>
          <PenLine className="mr-2 h-3 w-3" />Custom corporate dish description
        </button>
        <Command filter={(v, s) => (v.toLowerCase().includes(s.toLowerCase()) ? 1 : 0)}>
          <CommandInput placeholder="Type dish name…" data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>No menu item found.</CommandEmpty>
            <CommandGroup>
              {menu.map((m) => {
                const p = m.prices?.[center];
                return (
                  <CommandItem key={m.id} value={`${m.name} ${m.serves || ""} ${m.id}`} onSelect={() => { onPick(m); setOpen(false); }} data-testid={`${testid}-opt-${m.id}`}>
                    <span className="flex-1 truncate">{m.name}{m.serves ? <span className="text-slate-400"> · {m.serves}</span> : null}</span>
                    <span className="ml-2 text-[10px] text-slate-500">{p ? fmt(p, country) : "no price"}</span>
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
